import { Post } from '../types/post';

export const sortByDate = (a: Post, b: Post) => {
    if (a.is_pinned) {
        return -1;
    }
    return b.created_at.toMillis() - a.created_at.toMillis() > 0 ? 1 : -1;
};
